/* __next_internal_client_entry_do_not_use__ AlertType,NewLoginPopup auto */import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
  const data = _tagged_template_literal(["\n	background-color: #fff;\n	border-radius: 20px;\n	box-shadow: 0px 6px 20px 8px rgba(20, 16, 32, 0.06);\n	position: relative;\n	width: ", ";\n	height: ", ";\n	margin-top: ", ";\n	padding: ", ";\n	border-bottom-left-radius: ", ";\n	border-bottom-right-radius: ", ";\n	> .backBtn {\n		position: absolute;\n		left: 20px;\n		top: 20px;\n		z-index: 2;\n	}\n	> .closeBtn {\n		position: ", ";\n		right: 20px;\n		top: ", ";\n		width: 32px;\n		height: 32px;\n		display: flex;\n		align-items: center;\n		justify-content: center;\n		z-index: 2;\n		box-sizing: content-box;\n		transform: ", ";\n\n		padding: ", ";\n		> .iconBtn {\n			color: ", ";\n		}\n	}\n	> .scrollContainer {\n		overflow: hidden;\n		padding: 5px;\n		> .contentBox {\n			display: flex;\n			transition: all 0.1s ease;\n			gap: 10px;\n			/* height: 481px; */\n			&.nextPage {\n				height: fit-content;\n				/* &.reset {\n					height: 356px;\n				} */\n			}\n		}\n	}\n"]);
  _templateObject = function () {
    return data;
  };
  return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { VerifyPage } from "./pages/Verify";
import { HomeLogin } from "./pages/Home";
import { ResetPage } from "./pages/Reset";
import { useState } from "react";
import classNames from "classnames";
import { usePopups } from "@/store/popups";
import { TransparentIconButton } from "@/components/common/TransparentIconButton";
import { BaseIconButton } from "@/components/common/BaseIconButton";
import { close, left } from "@/assets/icons/svgV2";
import { isMobileOnly } from "react-device-detect";
export var AlertType;
(function (AlertType) {
  AlertType["register"] = "register";
  AlertType["invite"] = "invitation";
})(AlertType || (AlertType = {}));
export const NewLoginPopup = props => {
  const {
    showCreditsAlert,
    alertType = "register"
  } = props;
  const [pageState, setPageState] = useState("home");
  const [nextPage, setNextPage] = useState(false);
  const [data, setData] = useState({
    email: "",
    password: "",
    code: "",
    phone: "",
    p_code: ""
  });
  const popupDispatch = usePopups(state => state.dispatch);
  const changeAction = type => {
    setPageState(type);
    if (type === "home") {
      setNextPage(false);
      return;
    }
    setNextPage(true);
  };
  const changeAccountData = data => {
    if (data.password) {
      var _data_password;
      data.password = (_data_password = data.password) === null || _data_password === void 0 ? void 0 : _data_password.replace(/[^\x00-\xff]/g, "");
    }
    setData(pre => {
      return {
        ...pre,
        ...data
      };
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(NewLoginPopupCss, {
      isMobile: isMobileOnly,
      children: [pageState !== "home" && /*#__PURE__*/_jsx(BaseIconButton, {
        icon: left,
        className: "backBtn",
        iconSize: 20,
        size: "medium",
        preset: "secondary",
        onClick: () => {
          changeAction("home");
        }
      }), /*#__PURE__*/_jsx("div", {
        className: classNames("closeBtn"),
        onClick: () => {
          popupDispatch({
            type: "closeStack",
            payload: {}
          });
        },
        children: /*#__PURE__*/_jsx(TransparentIconButton, {
          size: 28,
          shape: "round",
          hoverBgColor: "rgba(242, 244, 247, 1)",
          icon: close,
          iconSize: 20,
          className: "iconBtn"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: classNames({
          scrollContainer: true
        }),
        children: /*#__PURE__*/_jsxs("div", {
          className: classNames({
            contentBox: true,
            nextPage: nextPage,
            [pageState]: true
          }),
          children: [pageState === "home" && /*#__PURE__*/_jsx(HomeLogin, {
            onSucc: props.onSuccess,
            data: data,
            changeAccountData: changeAccountData,
            changeHandle: changeAction
          }), pageState === "reset" && /*#__PURE__*/_jsx(ResetPage, {
            data: data,
            changeAccountData: changeAccountData
          }), pageState === "verify" && /*#__PURE__*/_jsx(VerifyPage, {
            onSucc: props.onSuccess,
            data: data,
            changeAccountData: changeAccountData,
            changeHandle: changeAction
          })]
        })
      })]
    })
  });
};
const NewLoginPopupCss = styled.div(_templateObject(), props => props.isMobile ? "100%" : "400px", props => props.isMobile ? "100%" : "auto", props => props.isMobile ? "100px" : "0", props => props.isMobile ? "5px" : "35px", props => props.isMobile ? "0" : "20px", props => props.isMobile ? "0" : "20px", props => props.isMobile ? "fixed" : "absolute", props => props.isMobile ? "0px" : "20px", props => props.isMobile ? "translateX(20px)" : "none", props => props.isMobile ? "9px 20px 9px calc(100% - 52px)" : "0", props => props.isMobile ? "var(--color-text-white)" : "var(--color-text-secondary)");